// extracted by mini-css-extract-plugin
export default {"header":"Gamification_header__hqQbm"};